import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils";
import styled from "styled-components";

export const GalleryFilterPillContainerToolbar = styled.nav<{
  isSticky: boolean;
  hasMultipleMediaTypes: boolean;
}>`
  position: sticky;
  z-index: 998;
  display: flex;
  align-items: center;
  top: ${({ isSticky, hasMultipleMediaTypes }) =>
    isSticky ? (hasMultipleMediaTypes ? "136px" : "78px") : "0"};
  background-color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  padding: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  transition: top 0.3s ease;

  button {
    display: inline-flex;
  }

  @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
    justify-content: center;
    top: ${({ isSticky }) => (isSticky ? "78px" : "0")};
  }
`;

export const GalleryFilterPillFlexWrapper = styled.ul`
  display: flex;
  padding: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)}
    ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  gap: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  overflow-x: scroll;
  overflow-y: hidden;
  scrollbar-width: none;
`;
